import { Menu as CssModulesMenu } from '@sunwebgroup/uds-ui/menu'
import { styled } from 'styled-components'

export const Root = Object.assign(
  styled(CssModulesMenu.Root)``,
  { displayName: 'Menu.Root' },
)

export const Content = Object.assign(
  styled(CssModulesMenu.Content)``,
  { displayName: 'Menu.Content' },
)

export const Item = Object.assign(
  styled(CssModulesMenu.Item)``,
  { displayName: 'Menu.Item' },
)

export const LinkItem = Object.assign(
  styled(CssModulesMenu.LinkItem)``,
  { displayName: 'Menu.LinkItem' },
)

export const Trigger = Object.assign(
  styled(CssModulesMenu.Trigger)``,
  { displayName: 'Menu.Trigger' },
)
